'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialPinterest = function TiSocialPinterest(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.8 8c-7 0-10.6 5-10.6 9.2 0 2.6 1 4.8 3 5.7 0.4 0.1 0.7 0 0.8-0.4 0.1-0.2 0.2-0.9 0.3-1.2 0.1-0.3 0-0.5-0.2-0.8-0.6-0.7-1-1.6-1-2.9 0-3.8 2.8-7.1 7.3-7.1 4 0 6.2 2.4 6.2 5.7 0 4.3-1.9 7.9-4.7 7.9-1.6 0-2.7-1.3-2.4-2.9 0.5-1.9 1.3-3.9 1.3-5.3 0-1.2-0.6-2.2-2-2.2-1.5 0-2.8 1.6-2.8 3.8 0 1.5 0.5 2.4 0.5 2.4s-1.7 6.9-2 8.1c-0.5 2.4 0 5.3 0 5.6 0 0.2 0.3 0.2 0.4 0.1 0.1-0.2 2-2.5 2.6-4.8 0.2-0.7 1.1-4.1 1.1-4.1 0.5 1 2 1.8 3.6 1.8 4.8 0 8-4.3 8-10.1 0-4.4-3.7-8.5-9.4-8.5z' })
        )
    );
};

exports.default = TiSocialPinterest;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-pinterest.js
// module id = 2185
// module chunks = 0